import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
export default {
    // https://devstoragebuzzebees.blob.core.windows.net/webconfig/Chanel/config/terms/
    apiGetPDPAContent: function(language) {
        const bzbConfig = Vue.bzbsConfig;
        const url = bzbConfig.bzbsBlobUrl  + `/webconfig/Chanel/config/terms/${language}.txt`;
        return new Promise((resolve,reject) =>{
            BzbsApi.connectBzbsGetBlob(url).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error);
            });
        })
    },
    apiGetBlobContent: function(language) {
        const bzbConfig = Vue.bzbsConfig;
        const url = bzbConfig.bzbsBlobUrl  + `/webconfig/Chanel/config/terms/${language}.txt`;
        return new Promise((resolve,reject) =>{
            BzbsApi.connectBzbsGetBlob(url).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error);
            });
        })
    },
}
